/**
 * Розетка на чертеже: силовая, слаботочная (ТВ, интернет) — любой блок розеток.
 *
 * Подложка — белый прямоугольник со скруглением под рамку розетки, символ —
 * из каталога. Компонент не знает, сколько постов в блоке и какой это стандарт:
 * это нарисовано в SVG типа, а здесь только форма и цвет.
 */
import { CatalogSymbol } from "../../CatalogSymbol";
import type { ElementShapeProps } from "./ElectricalItemShape";
import { ItemFrame, SELECTED_COLOR } from "./ItemFrame";

export const SocketShape = ({
	fixture,
	item,
	width,
	height,
	color,
	selected,
	...frame
}: ElementShapeProps) => {
	const px = (n: number) => n * frame.mmPerPx;
	return (
		<ItemFrame
			{...frame}
			fixtureId={fixture.id}
			width={width}
			height={height}
			color={color}
			selected={selected}
			backdrop={
				<rect
					x={-width / 2}
					y={-height / 2}
					width={width}
					height={height}
					rx={px(1.5)}
					fill="#ffffff"
					stroke={selected ? SELECTED_COLOR : color}
					strokeWidth={px(0.8)}
				/>
			}
		>
			<CatalogSymbol
				item={item}
				width={width}
				height={height}
				color={selected ? SELECTED_COLOR : color}
				mmPerPx={frame.mmPerPx}
			/>
		</ItemFrame>
	);
};

/** Розетка ли это по каталогу: разделы «Розетки» и «Слаботочка». */
